<template>
    <pop
        class="sign-log broker-new"
        :visibilityMode="true"
        :animation="popAnimation"
        :popMaskClass="popMaskClass || ''"
        :customClass="(popCustomClass || '') + 'sign-log'"
        :fbLeadClass="fbLeadClass"
        :allowClose="allowClose"
        :closeIcon="closeIcon"
        :onClose="onClose"
        ref="pop"
    >
        <template v-if="showType === 'register'">
            <register
                v-if="!showAdvRegister"
                type="register"
                :options="options"
                :changeType="changeType"
                :changeAllowClose="changeAllowClose"
            ></register>
            <advRegister
                v-else
                type="register"
                :options="options"
                :changeType="changeType"
                :changeAllowClose="changeAllowClose"
            ></advRegister>
        </template>
        <login
            v-if="showType === 'login'"
            type="login"
            :options="options"
            :changeType="changeType"
            :changeAllowClose="changeAllowClose"
        ></login>
    </pop>
</template>

<script>
import common from '../common.js';
import register from './register.vue';
import login from './login.vue';
import advRegister from '../advertising-register/register.vue';

export default {
    mixins: [common],
    components: {
        register,
        login,
        advRegister
    }
};
</script>

<style src="./index.scss" lang="scss"></style>
